module.exports = __webpack_public_path__ + "static/media/lc_jun.a970636c.png";